import { Component, Input, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-html-entity',
  styleUrls: ['./html-entity.component.scss'],
  template: '<div [innerHTML]="htmlCode"></div>',
  encapsulation: ViewEncapsulation.None,
})
export class HtmlEntityComponent {
  @Input() htmlCode: string = '';
}
